import React, { useCallback, useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import DashboardsContext from '../../../../contexts/DashboardsContext';
import moment from 'moment/moment';

const usePermittedDashboards = () => {
  const { allDashboards } = useContext(DashboardsContext);
  const getDashboards = useCallback(() => {
    return _.uniqBy(
      allDashboards.filter(
        (d) => !d.isWallboardSlide && !d.isTemplate && !d.isHidden,
      ),
      'id',
    );
  }, [allDashboards]);

  const [dashboards, setDashboards] = useState<DashboardType[]>(getDashboards);
  useEffect(() => {
    setDashboards(getDashboards());
  }, [getDashboards]);

  return dashboards;
};

const useDashboardOptions = ({
  selectedDashboard,
  setSelectedDashboard,
  setTitle,
}: {
  selectedDashboard: DashboardType | undefined;
  setSelectedDashboard: React.Dispatch<
    React.SetStateAction<DashboardType | undefined>
  >;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const dashboards = usePermittedDashboards();

  const buildOptions = useCallback((): DropdownOption[] => {
    return dashboards
      .filter(
        (d) =>
          !d.isTemplate &&
          d.templateId === undefined &&
          d.wallboardId === undefined &&
          !d.isWallboardSlide,
      )
      .map((d) => ({
        key: d.id,
        label: `${d.name}`,
        subLabel: `Created on: ${moment(d.createdOn).format('MMM DD, YY @ HH:mm')}`,
        isSelected: !!selectedDashboard && d.id === selectedDashboard.id,
        onSelected: () => {
          setSelectedDashboard(d);
          setTitle(d.name);
        },
      }));
  }, [dashboards, selectedDashboard, setSelectedDashboard, setTitle]);
  const [options, setOptions] = useState<DropdownOption[]>(buildOptions());
  useEffect(() => {
    setOptions(buildOptions());
  }, [buildOptions]);

  return options;
};

export default useDashboardOptions;
